export default function AreaChart(data, {
  container,
  x = ([x]) => x, // given d in data, returns the  x-value
  y = ([, y]) => y, // given d in data, returns the (quantitative) y-value
  curve = d3.curveStep, // how to interpolate between points
  marginTop = 20, // top margin, in pixels
  marginRight = 30, // right margin, in pixels
  marginBottom = 30, // bottom margin, in pixels
  marginLeft = 40, // left margin, in pixels
  width = 640, // outer width of chart, in pixels
  height = 400, // outer height of chart, in pixels
  xType = d3.scaleLinear, // the x-scale type
  xDomain, // [xmin, xmax]
  xRange = [marginLeft, width - marginRight], // [left, right]
  yType = d3.scaleLinear, // the y-scale type
  yDomain, // [ymin, ymax]
  yRange = [height - marginBottom, marginTop], // [bottom, top]
  color = "currentColor", // stroke color of line
  strokeLinecap = "butt", // stroke line cap of the line
  strokeLinejoin = "butt", // stroke line join of the line
  strokeWidth = 1.5, // stroke width of line, in pixels
  strokeOpacity = 1, // stroke opacity of line
  yFormat = ",", // a format specifier string for the y-axis
  yLabel = "", // a label for the y-axis,
  showXAxis = true,
  showYAxis = true
} = {}) {

  // Compute values.
  const X = d3.map(data, x);
  const Y = d3.map(data, y);
  const I = d3.range(X.length);
  const D = data;

  // Compute default domains.
  if (xDomain === undefined) xDomain = d3.extent(X);
  if (yDomain === undefined) yDomain = d3.extent(Y);

  // Construct scales and axes.
  const xScale = xType(xDomain, xRange);
  const yScale = yType(yDomain, yRange);
  const xAxis = d3.axisBottom(xScale).ticks(width / 100)
  const yAxis = d3.axisRight(yScale)
                  .ticks(6)
                  .tickFormat(function (d) {
                    if ((d / 1000000) >= 1)
                      d = d / 1000000 + "M";
                    else if ((d / 1000) >= 1)
                      d = d / 1000 + "K";
                    return d;
                  })

  // Construct a line generator.
  const line = d3.line()
      .defined(i => D[i])
      .curve(curve)
      .x(i => xScale(X[i]))
      .y(i => yScale(Y[i]));
  
  // Declare the area generator.
  const area = d3.area()
      .x(i => xScale(X[i]))
      .y0(yScale(0))
      .y1(i => yScale(Y[i]))
      .curve(curve);

  const svg = d3.select(container).append("svg")
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", [0, 0, width, height])
      .attr("style", "max-width: 100%; height: auto; height: intrinsic;");

  if (showXAxis) {
    svg.append("g")
        .attr("transform", `translate(0,${yScale(yDomain[0])})`)
        .call(xAxis);
  }

  if (showYAxis) {
    svg.append("g")
        .attr("transform", `translate(${marginLeft},0)`)
        .call(yAxis)
        .call(g => g.select(".domain").remove())
        .call(g => g.selectAll(".tick line").clone()
            .attr("class", "grid-line")
            .attr("x2", width - marginLeft - marginRight)
            .attr("stroke-opacity", 0.1))
        .call(g => g.append("text")
            .attr("x", -marginLeft)
            .attr("y", 20)
            .attr("fill", "currentColor")
            .attr("text-anchor", "start")
            .attr("class", "chart-title")
            .text(yLabel));
  }

  svg.append("path")
      .attr("fill", color)
      .attr("stroke", color)
      .attr("stroke-width", strokeWidth)
      .attr("stroke-linecap", strokeLinecap)
      .attr("stroke-linejoin", strokeLinejoin)
      .attr("stroke-opacity", strokeOpacity)
      .attr("d", area(I));

  return svg.node();
}

